import React, { forwardRef, useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import { FiEdit } from 'react-icons/fi';
import {
	requestListNotesByProtocol,
	requestUnitSectors,
	requestEditSetor,
} from '../../../services/requests';
import { requestNoteInfo } from '../../../services/newNotesRequest.js';

const NewNotificacaoPDF = forwardRef(({ notificacao, viewOnly = false }, ref) => {
	const [unitSectors, setUnitSectors] = useState([]);
	const [editSetor, setEditSetor] = useState(false);
	const [open, setOpen] = useState(false);
	const [search, setSearch] = useState('');
	const [setorEdited, setSetorEdited] = useState('');
	const [noteInfo, setNoteInfo] = useState(null);
	const protocolo = notificacao?.protocolo;
	const hasSensitiveNoteInfo =
		Boolean(notificacao?.nome_paciente) ||
		Boolean(notificacao?.sexo_paciente_display) ||
		Boolean(notificacao?.nascimento_paciente) ||
		Boolean(notificacao?.prontuario);
	const currentUser = JSON.parse(Cookies.get('user') || 'null');
	const availablePermissions = currentUser?.permissao || [];
	const canEditSetor =
		availablePermissions.includes('Classificadores') && !viewOnly;
	const currentCargo = currentUser?.cargo?.toLowerCase();
	const canViewNotifierData =
		availablePermissions.includes('Gestores') ||
		availablePermissions.includes('Classificadores') ||
		availablePermissions.includes('Desenvolvedores') ||
		currentCargo === 'gestor' ||
		currentCargo === 'classificador' ||
		currentCargo === 'desenvolvedor';

	useEffect(() => {
		const fetchNoteInfo = async () => {
			if (!protocolo || hasSensitiveNoteInfo) return;

			const token = JSON.parse(Cookies.get('user'))?.token;
			if (!token) return;

			const data = await requestNoteInfo(token, protocolo);
			setNoteInfo(data);
		};
		fetchNoteInfo();
	}, [protocolo, hasSensitiveNoteInfo]);

	const setoresAlbert = [
		'Centro Cirúrgico',
		'CME',
		'UTI Pediátrico',
		'UI Adulto',
		'UTI Adulto',
		'UCINCO (UTI Neonatal)',
		'UI Neonatal',
		'Centro Obstétrico',
		'Obstetrícia',
		'Cirurgia Ginecológica',
		'Enfermaria de RN',
		'UCINCA Canguru',
		'Cirurgia Geral',
		'Cirurgia Vascular',
		'Clínica Médica',
		'Ortopedia',
		'Pediatria',
		'UI Pediátrica',
		'Cirurgia Pediátrica',
	];

	const handleSectors = async () => {
		try {
			let unitId = notificacao?.unidade_id;

			// Se não tiver unitId, tenta buscar pela notificação
			if (!unitId) {
				const userCookie = Cookies.get('user');
				if (!userCookie || !notificacao?.protocolo) {
					setUnitSectors(setoresAlbert);
					return;
				}

				const { token } = JSON.parse(userCookie);
				if (!token) {
					setUnitSectors(setoresAlbert);
					return;
				}

				const note = await requestListNotesByProtocol(
					token,
					notificacao.protocolo,
				);

				unitId = note?.unidade_id;
			}

			// Se ainda não tem unitId, usa fallback
			if (!unitId) {
				setUnitSectors(setoresAlbert);
				return;
			}

			const sectors = await requestUnitSectors(unitId);

			if (Array.isArray(sectors) && sectors.length > 0) {
				setUnitSectors(sectors);
			} else {
				setUnitSectors(setoresAlbert);
			}
		} catch (error) {
			console.error('Erro ao carregar setores:', error);
			setUnitSectors(setoresAlbert);
		}
	};

	const [editedSetorForm, setEditedSetorForm] = useState({
		setor_ocorrencia: '',
		setor_adequado: true,
	});

	const handleEditSetor = async () => {
		try {
			if (!editedSetorForm.setor_ocorrencia) return; // nada selecionado
			const userCookie = Cookies.get('user');
			if (!userCookie) return;

			const { token } = JSON.parse(userCookie);
			if (!token || !notificacao?.protocolo) return;

			await requestEditSetor(
				token,
				notificacao.protocolo,
				editedSetorForm,
			);
		} catch (error) {
			console.error('Erro ao editar setor:', error);
		}
	};

	return (
		<div
			ref={ref}
			className=' bg-white font-inter'>
			{/* Header */}

			{/* <div className='bg-[#F0F4F8] flex rounded-sm w-full content-center min-h-[120px] p-[16px] gap-[20px] justify-between lg:flex-row flex-col'>
				<div className='content-center items-center mx-auto'>
					<img
						className='w-[200px] h-auto'
						src={logo}
						alt='logo'
					/>
				</div>
				<p className='text-[24px] font-bold text-[#13335A] content-center max-w-[600px] text-center'>
					NOTIFICAÇÃO DE INCIDENTES E NÃO CONFORMIDADES
				</p>
			</div> */}
			{/* Form Sections */}
			<div className='flex flex-col gap-[16px] mt-[16px]'>
				<div className='border rounded-lg py-4 px-3 flex flex-col gap-[12px]'>
					<div className='flex gap-[16px] w-full justify-between'>
						{/* Unidade */}
						<div className='flex flex-col w-full'>
							<p className='text-[#004A80] text-[16px] text-start font-medium'>
								Unidade
							</p>
							<div className='py-2 px-2 rounded-md border border-[#E3E3E3] flex items-center min-h-[40px]'>
								{notificacao?.unidade_nome ||
									'Não carregado...'}
							</div>
						</div>
						{/* Unidade */}
						<div className='flex flex-col w-full'>
							<p className='text-[#004A80] text-[16px] text-start font-medium'>
								Nº da notificação
							</p>
							<div className='py-2 px-2 rounded-md border border-[#E3E3E3] flex items-center min-h-[40px]'>
								{notificacao?.protocolo || 'Não carregado...'}
							</div>
						</div>
					</div>

					{/* Datas e Setor */}
					<div className='flex gap-[16px] flex-col xl:flex-row text-start'>
						<div className='flex flex-col w-full'>
							<p className='text-[#004A80] text-[16px] font-medium'>
								Data da Notificação
							</p>
							<div className='h-[40px] py-2 px-2 rounded-md border border-[#E3E3E3] flex items-center'>
								{notificacao?.data_notificacao
									?.split('T')[0]
									.split('-')
									.reverse()
									.join('/') || 'Não carregado...'}
							</div>
						</div>
						<div className='flex flex-col w-full'>
							<p className='text-[#004A80] text-[16px] font-medium'>
								Data da Ocorrência
							</p>
							<div className='h-[40px] py-2 px-2 rounded-md border border-[#E3E3E3] flex items-center'>
								{notificacao?.data_ocorrencia
									? notificacao?.data_ocorrencia
											?.split('-')
											.reverse()
											.join('/')
									: 'Não carregado...'}
							</div>
						</div>
						<div className='flex flex-col w-full'>
							<p className='text-[#004A80] text-[16px] font-medium'>
								Setor
							</p>
							{canEditSetor ? (
								editSetor ? (
									/* MODO EDIÇÃO */
									<div className='flex gap-2 items-center'>
										<div className='relative flex-1'>
											<input
												type='text'
												autoComplete='off'
												value={search}
												onChange={(e) => {
													const val = e.target.value;
													setSearch(val);
													setOpen(true);
													// qualquer digitação invalida seleção anterior
													setEditedSetorForm(
														(prev) => ({
															...prev,
															setor_ocorrencia:
																'',
														}),
													);
													setSetorEdited(false);
												}}
												onFocus={() => setOpen(true)}
												onBlur={() =>
													setTimeout(
														() => setOpen(false),
														150,
													)
												}
												placeholder='Selecione ou digite...'
												className={`w-full h-9 border rounded-md px-3 py-2 focus:outline-none focus:ring-2 transition-all duration-200 bg-white text-gray-700
												${
													setorEdited === false
														? 'border-red-500 focus:ring-red-500'
														: 'border-gray-300 focus:ring-blue-500'
												}`}
											/>
											{open &&
												(() => {
													const lista =
														unitSectors.length > 0
															? unitSectors
															: setoresAlbert;
													const filtrados =
														lista.filter((s) => {
															const nome = (
																s.nome ?? s
															)
																.normalize(
																	'NFD',
																)
																.replace(
																	/[\u0300-\u036f]/g,
																	'',
																)
																.toLowerCase();
															const q = (
																search ?? ''
															)
																.normalize(
																	'NFD',
																)
																.replace(
																	/[\u0300-\u036f]/g,
																	'',
																)
																.toLowerCase();
															return nome.includes(
																q,
															);
														});
													if (filtrados.length === 0)
														return null;
													return (
														<ul className='absolute z-50 w-full bg-white border border-gray-300 rounded-md top-10 max-h-48 overflow-y-auto text-start shadow-lg'>
															{filtrados.map(
																(s, i) => {
																	const nome =
																		s.nome ??
																		s;
																	return (
																		<li
																			key={`${nome}-${i}`}
																			onMouseDown={() => {
																				setEditedSetorForm(
																					(
																						prev,
																					) => ({
																						...prev,
																						setor_ocorrencia:
																							nome,
																					}),
																				);
																				setSetorEdited(
																					true,
																				);
																				setSearch(
																					nome,
																				);
																				setOpen(
																					false,
																				);
																			}}
																			className='px-3 py-2 cursor-pointer hover:bg-blue-100 transition-colors duration-150 text-sm text-gray-700'>
																			{
																				nome
																			}
																		</li>
																	);
																},
															)}
														</ul>
													);
												})()}
										</div>
										<button
											onClick={() => {
												handleEditSetor();
												setEditSetor(false);
											}}
											title='Confirmar edição'
											className='bg-[#cfcfcf] hover:bg-[#a8a8a8] text-white px-[7px] rounded-md shadow-sm transition-all duration-200 font-bold text-lg flex-shrink-0'>
											✓
										</button>
									</div>
								) : (
									/* MODO VISUAL COM BOTÃO EDITAR */
									<div className='relative flex gap-2 items-start   border border-[#E3E3E3] rounded-md py-1.5 px-2 '>
										<p
											className={`content-center transition-colors duration-300 ${
												setorEdited === false &&
												editedSetorForm.setor_ocorrencia ===
													''
													? 'text-gray-700'
													: setorEdited === false
														? 'text-red-500 font-medium'
														: 'text-gray-700'
											}`}>
											{editedSetorForm?.setor_ocorrencia
												?.length > 0
												? editedSetorForm.setor_ocorrencia
												: notificacao?.setor}
										</p>
										<button
											value={false}
											id='setor_adequado'
											onClick={() => {
												handleSectors();
												setEditedSetorForm((prev) => ({
													...prev,
													setor_adequado: false,
												}));
												setSetorEdited(false);
												setEditSetor(true);
												setSearch('');
											}}
											title='Editar setor'
											className='bg-[#bdbdbd]   shadow-md hover:bg-[#adadad] text-white p-1 rounded-md transition-all duration-200 ease-in-out hover:opacity-100'>
											<FiEdit className='h-4 w-4' />
										</button>
									</div>
								)
							) : (
								<div className='max-h-[100px] py-2 px-2 rounded-md border border-[#E3E3E3] flex items-center break-all'>
									{(notificacao?.setor || 'Não carregado...')
										.length > 60
										? notificacao?.setor.slice(0, 60) +
											'...'
										: notificacao?.setor}
								</div>
							)}
						</div>
						<div className='flex flex-col w-full'>
							<p className='text-[#004A80] text-[16px] font-medium'>
								Turno
							</p>
							<div className='h-[40px] py-2 px-2 rounded-md border border-[#E3E3E3] flex items-center'>
								{notificacao?.turno_display}
							</div>
						</div>
					</div>
				</div>

				{/* Detalhes notificante */}
				{/* {notificacao?.notificante.length > 0 && (
					<div className='flex p-2 border-[2px] bg-[#f3f7f8] rounded-md border-[#f3f7f8] gap-[8px] text-start pb-5'>
						<div className='flex flex-col w-full '>
							<p className='text-[#004A80] text-[16px] font-medium'>
								Notificador
							</p>
							<div>
								{notificacao?.notificante || 'Não carregado...'}
							</div>
						</div>

						<div className='flex flex-col w-full'>
							<p className='text-[#004A80] text-[16px] font-medium'>
								Cargo do notificador
							</p>
							<div>
								{notificacao?.notificante_cargo ||
									'Não carregado...'}
							</div>
						</div>
						<div className='flex flex-col w-full'>
							<p className='text-[#004A80] text-[16px] font-medium'>
								Setor do notificador
							</p>
							<div>
								{(
									notificacao?.notificante_setor.toLowerCase() ||
									'Não carregado...'
								).length > 60
									? notificacao?.notificante_setor
											.toLowerCase()
											.slice(0, 60) + '...'
									: notificacao?.notificante_setor.toLowerCase()}
							</div>
						</div>
					</div>
				)} */}

				{/* Paciente */}
				<div className='flex flex-col p-3 border-[2px] rounded-md border-[#E3E3E3] gap-[8px] text-start pb-3'>
					<div className='max-w-[265px]'>
						<p className='text-[#004A80] text-[16px] font-medium'>
							Relacionado a paciente?
						</p>
						<div className='flex gap-[15px]'>
							<div className='border border-[#E3E3E3] rounded-md px-2 py-2 w-full min-h-[40px] flex items-center'>
								{notificacao?.envolve_paciente === true
									? 'Sim'
									: 'Não'}
							</div>
						</div>
					</div>

					{/* Detalhes paciente */}
					{notificacao?.envolve_paciente === true && (
						<div className='flex gap-[16px] flex-col xl:flex-row mt-2 '>
							<div className='flex flex-col w-full mb-2'>
								<p className='text-[#004A80] text-[16px] font-medium'>
									Nome
								</p>
								<div className='border border-[#E3E3E3] px-2 py-2 rounded-md min-h-[40px] flex items-center'>
									{notificacao?.nome_paciente ||
										noteInfo?.nome_paciente ||
										'Não carregado...'}
								</div>
							</div>
							<div className='flex flex-col w-full'>
								<p className='text-[#004A80] text-[16px] font-medium'>
									Sexo
								</p>
								<div className='border border-[#E3E3E3] px-2 py-2 rounded-md min-h-[40px] flex items-center'>
									{notificacao?.sexo_paciente_display ||
										noteInfo?.sexo_paciente_display ||
										'Não carregado...'}
								</div>
							</div>
							<div className='flex flex-col w-full'>
								<p className='text-[#004A80] text-[16px] font-medium'>
									Data de Nascimento
								</p>
								<div className='border border-[#E3E3E3] px-2 py-2 rounded-md min-h-[40px] flex items-center'>
									{notificacao?.nascimento_paciente
										? notificacao?.nascimento_paciente
												.split('-')
												.reverse()
												.join('/')
										: noteInfo?.nascimento_paciente
											? noteInfo?.nascimento_paciente
													.split('-')
													.reverse()
													.join('/')
											: 'Não carregado...'}
								</div>
							</div>
							<div className='flex flex-col w-full'>
								<p className='text-[#004A80] text-[16px] font-medium'>
									Prontuário/BE
								</p>
								<div className='border border-[#E3E3E3] px-2 py-2 rounded-md min-h-[40px] flex items-center'>
									{notificacao?.prontuario ||
										noteInfo?.prontuario ||
										'Não carregado...'}
								</div>
							</div>
						</div>
					)}
				</div>

				{canViewNotifierData && (
					<>
						{/* IDENTIFICAÇÃO DO NOTIFICADOR */}
						<div className='flex gap-[30px] flex-col xl:flex-row transition-all duration-300 bg-[#F4F4F4] p-[15px] rounded-md'>
							<div className='flex flex-col w-full'>
								<div className='flex gap-2'>
									<p className='text-[#004A80] text-[16px] font-medium '>
										{' '}
										Identificação do Notificador{' '}
									</p>
									<p className='text-[#999999] text-[16px] font-normal '>
										{' '}
										(opcional){' '}
									</p>
								</div>
								<div className='border-[1px] bg-white rounded-md text-gray-500 border-[#E3E3E3] py-1 px-2 placeholder:text-[#E3E3E3] h-[40px] flex items-center'>
									{notificacao?.notificante ||
										'Não informado'}
								</div>
							</div>

							<div className='flex flex-col w-full'>
								<div className='flex gap-2'>
									<p className='text-[#004A80] text-[16px] font-medium '>
										{' '}
										Setor Notificador{' '}
									</p>
									<p className='text-[#999999] text-[16px] font-normal '>
										{' '}
										(obrigatório){' '}
									</p>
								</div>
								<div
									type='text'
									className='border-[1px] bg-white rounded-md text-gray-500 border-[#E3E3E3] py-1 px-2 placeholder:text-[#E3E3E3] h-[40px] flex items-center'>
									{notificacao?.notificante_setor ||
										'Não informado'}
								</div>
							</div>

							<div className='flex flex-col w-full'>
								<div className='flex gap-2'>
									<p className='text-[#004A80] text-[16px] font-medium '>
										{' '}
										Cargo Notificador{' '}
									</p>
									<p className='text-[#999999] text-[16px] font-normal '>
										{' '}
										(opcional){' '}
									</p>
								</div>
								<div className='border-[1px] bg-white rounded-md text-gray-500 border-[#E3E3E3] py-1 px-2 placeholder:text-[#E3E3E3] h-[40px] flex items-center'>
									{notificacao?.notificante_cargo ||
										'Não informado'}
								</div>
							</div>
						</div>
					</>
				)}

				{/* Incidentes */}
				<div className='flex flex-col p-3 border-[2px] rounded-md border-[#E3E3E3] gap-[8px] text-start'>
					<div className='flex gap-[16px] '>
						<div className='w-full my-2'>
							{' '}
							<p className='text-[#004A80] text-[16px] font-medium mb-1'>
								Incidentes e não conformidades
							</p>
							<div>
								{notificacao?.tipo_incidente_display ||
									'Não carregado...'}
							</div>
						</div>
						{notificacao?.tipo_incidente_outros && (
							<div className='w-full'>
								<p className='text-[#004A80] text-[16px] font-medium'>
									Descrição do incidente
								</p>

								<div>
									{notificacao?.tipo_incidente_outros ||
										'Não carregado...'}
								</div>
							</div>
						)}
					</div>
					<div className='flex gap-[16px] my-[8px] bg-[#f3f7f8] p-2 rounded-md '>
						<div className='flex flex-col w-full pb-2'>
							<p className='text-[#004A80] text-[16px] font-medium'>
								Presenciado por alguém?
							</p>
							<div>
								{notificacao?.fato_presenciado === true
									? 'Sim'
									: 'Não'}
							</div>
						</div>
						{notificacao?.fato_presenciado === true && (
							<div className='flex flex-col w-full'>
								<p className='text-[#004A80] text-[16px] font-medium'>
									Nome
								</p>
								<div>
									{notificacao?.quem_presenciou ||
										'Não carregado...'}
								</div>
							</div>
						)}
					</div>
				</div>

				{/* Textareas como divs */}
				<div className='flex flex-col text-start'>
					<p className='text-[#004A80] text-[16px] font-medium'>
						Descrição da ocorrência
					</p>
					<div className='py-2 border rounded-md border-[#E3E3E3] p-2 whitespace-pre-wrap break-words leading-relaxed'>
						{notificacao?.descricao || 'Não carregado...'}
					</div>
				</div>
				<div className='flex flex-col text-start'>
					<p className='text-[#004A80] text-[16px] font-medium'>
						Ações imediatas tomadas
					</p>
					<div className='py-2 border rounded-md border-[#E3E3E3] p-2 whitespace-pre-wrap break-words leading-relaxed'>
						{notificacao?.acoes_imediatas || 'Não carregado...'}
					</div>
				</div>
				<div className='flex flex-col text-start'>
					<p className='text-[#004A80] text-[16px] font-medium'>
						Medidas preventivas
					</p>
					<div className='py-2 border rounded-md border-[#E3E3E3] p-2 whitespace-pre-wrap break-words leading-relaxed'>
						{notificacao?.medida_preventiva || 'Não carregado...'}
					</div>
				</div>
			</div>
		</div>
	);
});

export default NewNotificacaoPDF;
